<template>
    <div class="news-page">
        <div class="banner">
            <img  src="@/assets/banner1.png" alt=""/>
        </div>
        <div class="main">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
@import "@/scss/home/news.scss";
</style>